import { Field, useFormikContext } from 'formik'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useResolvedAppTestProduct } from '@pages/ProductRegistration/AppropriatenessTest/hooks/useResolvedAppTestProduct'
import { useDocumentMarketDataIdState } from '@pages/ProductRegistration/LegalDocuments/ReadDocumentMarketDataPage'

import { useAccountReadContext } from '@context/AccountContextContext'

import { isProductMarketDataClassificationSet } from '@utils/AccountAccess/accountProductStatuses'
import { validateIsNumberPositive } from '@utils/formValidation'

import { ReadAndAgree } from '../../Signup/Pages/PersonalDetails/PersonalDetailsStep6/DocumentItemFactory'
import { LegalDocumentsValues } from './LegalDocumentsForm'

export const DocumentMarketDataClassifications: React.FC = () => {
  const { t } = useTranslation()
  const { account } = useAccountReadContext()
  const { values, setFieldValue, validateForm } = useFormikContext<LegalDocumentsValues>()
  const resolvedProductId = useResolvedAppTestProduct()
  const { setMarketDataClassificationId, marketDataClassificationId } =
    useDocumentMarketDataIdState()

  useEffect(() => {
    validateForm()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.readDocumentMarketData?.marketDataClassificationId])

  const handleMarketDataAgreementAccept = () => {
    setFieldValue('readDocumentMarketData', {
      marketDataClassificationId: 0,
      isDocumentMarketDataRead: true,
      isDocumentMarketDataAccepted: false,
    })
  }

  useEffect(() => {
    if (
      isProductMarketDataClassificationSet(account, resolvedProductId) &&
      !values.readDocumentMarketData.isDocumentMarketDataAccepted &&
      account?.marketDataClassification?.id
    ) {
      if (marketDataClassificationId !== account?.marketDataClassification?.id) {
        setMarketDataClassificationId(account?.marketDataClassification?.id)
      }
      setFieldValue('readDocumentMarketData', {
        marketDataClassificationId: account?.marketDataClassification?.id,
        isDocumentMarketDataRead: false,
        isDocumentMarketDataAccepted: true,
      })
    }
  }, [
    account,
    marketDataClassificationId,
    resolvedProductId,
    setFieldValue,
    setMarketDataClassificationId,
    values.readDocumentMarketData.isDocumentMarketDataAccepted,
  ])

  return (
    <div className='mb-5'>
      <Field
        name='readDocumentMarketData.marketDataClassificationId'
        validate={validateIsNumberPositive(t('Validation.Required'))}
      >
        {() => (
          <ReadAndAgree
            title={t('Sign up.Tickmill UK Ltd. Exchange Market Data Agreement')}
            isAccepted={values.readDocumentMarketData.isDocumentMarketDataAccepted}
            documents={[]}
            onClick={handleMarketDataAgreementAccept}
          />
        )}
      </Field>
    </div>
  )
}
